<template>
  <div class="full fs-menu">

    <div class="close-row">
      <img src="./img/close.svg" @click="() => { $emit('close') }" />
    </div>

    <div class="lang-row">
      <div class="lang-item" @click="$emit('lang');">
        <div>{{ T('#menu@lang') }}</div>
        <div class="lang-line"></div>
      </div>
    </div>

    <div class="item-row" :key="menu.eTitle" v-for="menu in menus">
      <div class="item-entry" @click="$router.push(menu.link); $emit('close');">
        <span v-if="SC.U === ENG">{{ menu.eTitle }}</span>
        <span v-if="SC.U === CHI">{{ menu.cTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Text from '@/components/DOM/Text/Text.js'

export default {
  data () {
    return {
      T: Text.T,
      SC: Text.state,
      ENG: Text.ENG,
      CHI: Text.CHI,
      menus: [
        {
          eTitle: 'Home',
          cTitle: '首頁',
          link: {
            path: '/',
            hash: false
          }
        },

        // {
        //   eTitle: 'Radiance Moment',
        //   cTitle: '閃耀力量時刻',
        //   link: {
        //     path: '/',
        //     hash: 'kol'
        //   }
        // },
        {
          eTitle: 'About Clé de Peau Beauté',
          cTitle: '關於 Clé de Peau Beauté',
          link: {
            path: '/about',
            hash: 'cdp'
          }
        },
        {
          eTitle: 'About Radiance Is',
          cTitle: '關於 Radiance Is',
          link: {
            path: '/about',
            hash: false
            // hash: 'radianceis'
          }
        },
        // {
        //   eTitle: 'About Make A Wish',
        //   cTitle: '關於願望成真基金',
        //   link: {
        //     path: '/',
        //     hash: false
        //   }
        // },
        // {
        //   eTitle: 'About Cle de Peau Beaute',
        //   cTitle: '關於Clé de Peau Beauté',
        //   link: {
        //     path: '/',
        //     hash: false
        //   }
        // },
        {
          eTitle: 'Wish Children',
          cTitle: '願望童',
          link: {
            path: '/kids-wishes',
            hash: false
          }
        },
        {
          eTitle: 'Receive Our Latest News',
          cTitle: '閃耀資訊',
          link: {
            path: '/data-form',
            hash: false
          }
        }
        // ,
        // {
        //   eTitle: 'Radiant Eye Cream Charity Set',
        //   cTitle: '修護眼霜慈善套裝',
        //   link: {
        //     path: '/radiance-set',
        //     hash: false
        //   }
        // }

      ]
    }
  }
}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
.fs-menu{
  background-color: #060C26;
}
.close-row{
  margin-top: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lang-row{
  /* 繁: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  color: #C6B9A3;
  letter-spacing: 1.85px;
  text-align: center;
  line-height: 12px;

  margin-top: 6px;
  height: calc(100% / 6);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.lang-item{
  display: inline-block;
  text-align: center;
}
.lang-line{
  display: inline-block;
  height: 1px;
  width: 100%;
  border-bottom: #C6B9A3 solid 1px;
}
.item-row:nth-child(1){
  margin-top: 5%;
}
.item-row{
  height: calc(100% / 10 * 1.3);
  width: 100%;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 31px;

}
.item-entry{
  cursor: pointer;
  transition: color 0.3s;
}
.item-row:hover .item-entry{
  color: #C6B9A3;
}

@media screen and (min-width: 767px){
  .item-entry{
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DOM/FullMenu/FullMenu.vue